import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class OrganizationsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/organizations", { params: toSnakeCase(params) });
  }
}

export default new OrganizationsService();
